var map = {
	"./advanced_maze_solver.png": 256,
	"./binomial_machine.png": 943,
	"./double_pendulum_simulator.png": 851,
	"./elastic_collider.png": 78,
	"./graph_generator.png": 330,
	"./n_body_simulation.png": 609,
	"./optimal_odyssey.png": 789,
	"./pandemic_simulator.png": 144,
	"./personal_website.png": 724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 988;